module.exports = __webpack_public_path__ + "static/media/photo_016.1e47cfe7.JPG";